// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LdKFD0 {
  position: sticky;
  top: 88px;
  display: flex;
  flex-direction: column;
  background: var(--surface-neutral-white);
  border-radius: 4px;
  box-shadow: 0 2px 2px #0000001f;
  height: max(748px, calc(100dvh - 160px));
  align-self: start;
}
@media (max-width: 1023px), (max-height: 835px) {
  .LdKFD0 {
    position: static;
  }
}
.LdKFD0 h2 {
  font-size: 16px;
  font-weight: 400;
  line-height: 23px;
  padding: 24px 24px 16px;
  height: 64px;
  flex-shrink: 0;
  margin: 0;
  border-bottom: 1px solid #e6e6e6;
}
.EGC6hI {
  padding: 24px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.L3wHEE {
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 24px;
}
.n5MJ8b {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rUux3_ {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 1.8;
}
.rUux3_ strong {
  font-weight: 600;
}
.rUux3_ p {
  margin: 0;
}
.vopEgQ {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  flex-shrink: 0;
  cursor: pointer;
}
.vopEgQ img {
  width: 24px;
  height: 24px;
}
.vopEgQ:disabled {
  cursor: not-allowed;
}
.DnsT_E {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.QQ7TKx {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
  --checkbox-border: #1f1f1f;
  --checkbox-border-radius: 2px;
  --checkbox-checked-background: #d64000;
  --checkbox-checked-border: #d64000;
}
.QQ7TKx > label {
  flex-shrink: 0;
}
.QQ7TKx input {
  margin: 0;
}
.QQ7TKx a {
  color: var(--text-neutral-dark);
  text-decoration: underline;
  text-underline-position: from-font;
}
.D5cdut {
  height: 40px;
  min-height: 40px;
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  border-width: 0;
}
.UTsQc2 {
  color: var(--text-error);
  font-size: 14px;
  margin: 0;
}
@media (max-width: 1023px) {
  .LdKFD0 {
    height: auto;
    min-height: 480px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/BenefitMigrationPage/components/MigrationConfirmation.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;EACxC,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,SAAS;AACX;AACA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".card {\n  position: sticky;\n  top: 88px;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-neutral-white);\n  border-radius: 4px;\n  box-shadow: 0 2px 2px #0000001f;\n  height: max(748px, calc(100dvh - 160px));\n  align-self: start;\n}\n@media (max-width: 1023px), (max-height: 835px) {\n  .card {\n    position: static;\n  }\n}\n.card h2 {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 23px;\n  padding: 24px 24px 16px;\n  height: 64px;\n  flex-shrink: 0;\n  margin: 0;\n  border-bottom: 1px solid #e6e6e6;\n}\n.body {\n  padding: 24px;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.address {\n  border-bottom: 1px solid #f2f2f2;\n  padding-bottom: 24px;\n}\n.addressRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.addressText {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 1.8;\n}\n.addressText strong {\n  font-weight: 600;\n}\n.addressText p {\n  margin: 0;\n}\n.edit {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n.edit img {\n  width: 24px;\n  height: 24px;\n}\n.edit:disabled {\n  cursor: not-allowed;\n}\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.consent {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  --checkbox-border: #1f1f1f;\n  --checkbox-border-radius: 2px;\n  --checkbox-checked-background: #d64000;\n  --checkbox-checked-border: #d64000;\n}\n.consent > label {\n  flex-shrink: 0;\n}\n.consent input {\n  margin: 0;\n}\n.consent a {\n  color: var(--text-neutral-dark);\n  text-decoration: underline;\n  text-underline-position: from-font;\n}\n.submit {\n  height: 40px;\n  min-height: 40px;\n  width: 100%;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 600;\n  border-width: 0;\n}\n.error {\n  color: var(--text-error);\n  font-size: 14px;\n  margin: 0;\n}\n@media (max-width: 1023px) {\n  .card {\n    height: auto;\n    min-height: 480px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `LdKFD0`,
	"body": `EGC6hI`,
	"address": `L3wHEE`,
	"addressRow": `n5MJ8b`,
	"addressText": `rUux3_`,
	"edit": `vopEgQ`,
	"actions": `DnsT_E`,
	"consent": `QQ7TKx`,
	"submit": `D5cdut`,
	"error": `UTsQc2`
};
module.exports = ___CSS_LOADER_EXPORT___;
